import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'Performance Overview Sub Branch',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  performanceOverviewSubBranchRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  performanceOverviewSubBranchCompareRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const performanceOverviewSubBranch = createSlice({
  name: 'performanceOverviewSubBranch',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => ({ ...state, currentQuarter: action.payload }),
    setCurrentYear: (state, action) => ({ ...state, currentYear: action.payload }),
    setSelectedQuarter: (state, action) => ({ ...state, selectedQuarter: action.payload }),
    setSelectedYear: (state, action) => ({ ...state, selectedYear: action.payload }),
    setCompareSelectedYear: (state, action) => ({ ...state, compareSelectedYear: action.payload }),
    setCompareSelectedQuarter: (state, action) => ({
      ...state,
      compareSelectedQuarter: action.payload,
    }),
    setPerformanceOverviewSubBranchRange: (state, action) => ({
      ...state,
      performanceOverviewSubBranchRange: action.payload,
    }),
    setPerformanceOverviewSubBranchCompareRange: (state, action) => ({
      ...state,
      performanceOverviewSubBranchCompareRange: action.payload,
    }),
  },
});

export const performanceOverviewSubBranchActions = performanceOverviewSubBranch.actions;

export default performanceOverviewSubBranch.reducer;
